import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default React.memo(function SlideOverlay({ label, title, description, ctaText, ctaUrl, children }) {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const navbarHeight = 100;
      const topOffset =
        section.getBoundingClientRect().top + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };

  const handleCtaClick = (e, url) => {
    e.preventDefault();
    if (url.startsWith("#")) {
      scrollToSection(url.substring(1));
    } else {
      navigate(url);
    }
  };

  return (
    <div className="absolute h-full w-full min-w-full max-w-7xl px-4 sm:px-6 lg:px-8 flex flex-col justify-start mt-[8rem] sm:mt-[8rem] lg:mt-[8rem] z-20 pointer-events-none">
      <motion.div
        className="max-w-xl w-full text-left pointer-events-auto"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -30 }}
        transition={{
          opacity: { duration: 0.5 },
          y: { duration: 0.7, ease: "easeOut" },
        }}
        style={{ transition: "transform 0.3s ease-out", willChange: "transform, opacity" }}
      >
        <p className="text-base font-medium text-white mb-2 leading-[1.2] lg:ml-2">
          {label}
        </p>
        <h1
          className="w-full font-bold text-white mb-6 font-antonio text-[10vh] leading-[12vh] sm:text-[13vh] sm:leading-[15vh] md:text-[18vh] md:leading-[20vh]"
          style={{
            fontSize: "clamp(6vh, 10vw, 13vh)",
            lineHeight: "clamp(7vh, 12vw, 15vh)",
          }}
        >
          {title}
        </h1>
      </motion.div>

      <motion.div
        initial={{ y: 40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="max-w-xl flex flex-col gap-4 lg:ml-2 text-left z-10 pointer-events-auto"
      >
        <p className="text-xl sm:text-2xl text-white/90 leading-relaxed">
          {description}
        </p>
        <motion.div
          initial={{ y: 40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          <button
            onClick={(e) => handleCtaClick(e, ctaUrl)}
            aria-label={`${ctaText} - ${title}`}
            className="text-lg px-6 py-3 rounded-full bg-brandPrimary hover:bg-brandAccent text-white font-medium shadow-md transition duration-300"
          >
            {ctaText}
          </button>
        </motion.div>
      </motion.div>
      {children}
    </div>
  );
});
